
import React from 'react';
import FAQItem from '@/components/FAQItem';

type FAQ = {
  question: string;
  answer: string;
};

type FAQSectionProps = {
  faqs: FAQ[];
};

const FAQSection = ({ faqs }: FAQSectionProps) => {
  // Add the new FAQ about seeing real cats
  const enhancedFaqs = [
    ...faqs,
    {
      question: "Will guests see real cats on the tour?",
      answer: "While our tours are primarily about historical cats who've long since used up their nine lives, we do keep our eyes peeled for modern-day feline celebrities! Sometimes they grace us with their presence in windows or on stoops, but like all cats, they operate on their own mysterious schedule. We make no guarantees about cat sightings—they're notoriously bad at keeping appointments!"
    }
  ];

  return (
    <section className="mb-16">
      <h2 className="section-title-left mb-6">Frequently Asked Questions</h2>
      <div className="space-y-4">
        {enhancedFaqs.map((faq, index) => (
          <FAQItem 
            key={index}
            question={faq.question}
            answer={faq.answer}
            isOpen={index === 0}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
